let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lawvr")).then(() => parcelRequire('dG3Q6'));